import { render, staticRenderFns } from "./BaseNotification.vue?vue&type=template&id=5e1221f0&scoped=true&"
import script from "./BaseNotification.vue?vue&type=script&lang=js&"
export * from "./BaseNotification.vue?vue&type=script&lang=js&"
import style0 from "./BaseNotification.vue?vue&type=style&index=0&id=5e1221f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1221f0",
  null
  
)

export default component.exports